{
  "version": 1,
  "asset_id": "6d868c2e-79b0-465b-914d-bc3a3b3daea7",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6d868c2e-79b0-465b-914d-bc3a3b3daea7/hardware-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6d868c2e-79b0-465b-914d-bc3a3b3daea7/hardware-thumb.webp",
  "original_filename": "hardware-thumb.webp",
  "size": 9854,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:27Z"
}
